{
  "name": "@bfra.me/eslint-config",
  "version": "0.52.1",
  "description": "Shared ESLint configuration for bfra.me",
  "keywords": [
    "bfra.me",
    "config",
    "eslint",
    "eslint-config",
    "shared",
    "typescript",
    "works"
  ],
  "homepage": "https://github.com/bfra-me/works/tree/main/packages/eslint-config#readme",
  "bugs": "https://github.com/bfra-me/works/issues",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/bfra-me/works.git",
    "directory": "packages/eslint-config"
  },
  "license": "MIT",
  "author": "Marcus R. Brown <contact@bfra.me>",
  "type": "module",
  "exports": {
    ".": {
      "types": "./lib/index.d.ts",
      "source": "./src/index.ts",
      "import": "./lib/index.js"
    },
    "./package.json": "./package.json"
  },
  "main": "./lib/index.js",
  "types": "./lib/index.d.ts",
  "files": [
    "!**/*.map",
    "lib",
    "src"
  ],
  "scripts": {
    "build": "pnpm run generate-types && tsup-node",
    "build-inspector": "eslint-config-inspector build --config ./eslint.config.ts",
    "dev": "eslint-config-inspector --config ./eslint.config.ts --open false",
    "generate-types": "tsx ./scripts/generate-types.ts",
    "prepack": "pnpm --filter-prod=\"{.}...\" run build",
    "test": "vitest run"
  },
  "dependencies": {
    "@bfra.me/es": "workspace:*",
    "@eslint-community/eslint-plugin-eslint-comments": "4.7.2",
    "@eslint/markdown": "8.0.3",
    "@stylistic/eslint-plugin": "5.10.0",
    "eslint-config-flat-gitignore": "2.3.0",
    "eslint-flat-config-utils": "3.2.0",
    "eslint-merge-processors": "2.0.0",
    "eslint-plugin-command": "4.0.0",
    "eslint-plugin-import-x": "4.17.1",
    "eslint-plugin-jsdoc": "64.2.1",
    "eslint-plugin-json-schema-validator": "6.3.1",
    "eslint-plugin-jsonc": "3.4.2",
    "eslint-plugin-n": "18.3.0",
    "eslint-plugin-perfectionist": "5.10.1",
    "eslint-plugin-regexp": "3.2.0",
    "eslint-plugin-toml": "1.5.0",
    "eslint-plugin-unicorn": "73.0.0",
    "eslint-plugin-unused-imports": "4.4.1",
    "eslint-plugin-yml": "3.8.1",
    "globals": "17.11.0",
    "is-in-ci": "2.0.0",
    "local-pkg": "1.2.1",
    "package-manager-detector": "1.8.0",
    "sort-package-json": "4.0.0",
    "typescript-eslint": "8.67.0"
  },
  "devDependencies": {
    "@bfra.me/prettier-config": "workspace:*",
    "@bfra.me/tsconfig": "workspace:*",
    "@bfra.me/works": "workspace:*",
    "@eslint-react/eslint-plugin": "5.18.6",
    "@eslint/config-inspector": "3.3.0",
    "@eslint/core": "1.2.1",
    "@next/eslint-plugin-next": "16.3.2",
    "@types/eslint-config-prettier": "6.11.3",
    "@types/eslint-plugin-jsx-a11y": "6.10.1",
    "@typescript-eslint/types": "8.67.0",
    "@vitest/eslint-plugin": "1.6.27",
    "astro-eslint-parser": "3.1.0",
    "eslint": "10.9.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-astro": "3.1.0",
    "eslint-plugin-erasable-syntax-only": "0.7.1",
    "eslint-plugin-jsx-a11y": "6.10.2",
    "eslint-plugin-node-dependencies": "2.2.0",
    "eslint-plugin-pnpm": "1.8.0",
    "eslint-plugin-prettier": "5.5.6",
    "eslint-plugin-react-hooks": "7.1.1",
    "eslint-plugin-react-refresh": "0.5.4",
    "eslint-typegen": "2.3.1"
  },
  "peerDependencies": {
    "@eslint-react/eslint-plugin": "^4.2.3 || ^5.0.0",
    "@next/eslint-plugin-next": ">=15.5.3",
    "@vitest/eslint-plugin": "^1.1.21",
    "astro-eslint-parser": "^1.2.2 || ^3.0.0",
    "eslint": "^9.38.0 || ^10.0.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-astro": "^1.3.1 || ^3.0.0",
    "eslint-plugin-jsx-a11y": ">=6.10.2",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-react-hooks": "^7.0.0",
    "eslint-plugin-react-refresh": "^0.4.20 || ^0.5.0"
  },
  "peerDependenciesMeta": {
    "@eslint-react/eslint-plugin": {
      "optional": true
    },
    "@next/eslint-plugin-next": {
      "optional": true
    },
    "@vitest/eslint-plugin": {
      "optional": true
    },
    "astro-eslint-parser": {
      "optional": true
    },
    "eslint-config-prettier": {
      "optional": true
    },
    "eslint-plugin-astro": {
      "optional": true
    },
    "eslint-plugin-jsx-a11y": {
      "optional": true
    },
    "eslint-plugin-prettier": {
      "optional": true
    },
    "eslint-plugin-react-hooks": {
      "optional": true
    },
    "eslint-plugin-react-refresh": {
      "optional": true
    }
  },
  "engines": {
    "node": "^22.22.2 || >=24.15.0"
  },
  "publishConfig": {
    "access": "public",
    "provenance": true
  }
}
